import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoginScreen } from './components/LoginScreen';
import { QueueDashboard } from './components/QueueDashboard';
function AppContent() {
  const {
    user,
    login
  } = useAuth();
  if (!user) {
    return <LoginScreen onLogin={login} data-id="element-0" />;
  }
  return <div className="w-full min-h-screen bg-gradient-to-br from-blue-50 to-slate-100" data-id="element-1">
      <QueueDashboard data-id="element-2" />
    </div>;
}
export function App() {
  return <AuthProvider data-id="element-3">
      <AppContent data-id="element-4" />
    </AuthProvider>;
}